import { render, staticRenderFns } from "./Istanbul.vue?vue&type=template&id=31718e88&"
import script from "./Istanbul.vue?vue&type=script&lang=js&"
export * from "./Istanbul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports